import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import dt from '../../../../../shared/theme';
import Checkbox from '../../../../shared/checkbox';
import TextSeparator from '../../../common/styles';
import useFundsStateStore from '../../../common/funds-state-hook';

const Container = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 8px;

  &:hover {
    border-radius: 6px;
    background: #F5F6F9;
    cursor: pointer;
  }
`;

const Label = styled.span`
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  font-size: 16px;
  text-transform: uppercase;

  span.count {
    font-weight: ${props => dt(props).theme.fontWeightRegular};
  }
`;

export default function Option({ assetClass }) {
  const set = useFundsStateStore(state => state.set);
  const filteredAssetClasses = useFundsStateStore(state => state.filters.assetClasses);
  const {
    id, name, count,
  } = assetClass;

  const handleClick = () => {
    const newSelectedAssetClasses = filteredAssetClasses.includes(id)
      ? _.without(filteredAssetClasses, id)
      : [...filteredAssetClasses, id];

    set(state => {
      state.filters.assetClasses = newSelectedAssetClasses;
    });
  };

  return (
    <Container onClick={handleClick}>
      <Label>
        {name}
        <TextSeparator>&bull;</TextSeparator>
        <span className="count">{count}</span>
      </Label>
      <Checkbox className={classNames('fa fa-border', { 'fa-check': filteredAssetClasses.includes(id) })} />
    </Container>
  );
}

Option.propTypes = {
  assetClass: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
  }).isRequired,
};
